import CREATE_PREFERRED_LAB_VENDOR from "../mutations/vendors/create-preferred-lab-vendor";

function createPreferredLabVendor(memberId, labVendorId, client) {
  return client.mutate({
    mutation: CREATE_PREFERRED_LAB_VENDOR,
    fetchPolicy: 'no-cache',
    variables:   { memberId, labVendorId }
  });
}

export default createPreferredLabVendor;
